import { useEffect } from 'react'

import { runBootstrapApiReachabilityProbe } from '@/services/serviceReachabilityMonitor'

/**
 * Runs a one-shot GraphQL reachability check when the shell (Layout) mounts,
 * so users see the downtime toast even if no query has errored yet.
 */
export function useBootstrapApiReachabilityProbe(): void {
  useEffect(() => {
    void runBootstrapApiReachabilityProbe()
  }, [])
}
